import React, { useEffect, useState } from "react";
import AdSlot from "./AdSlot";

export default function PageWithSideAds({ children }) {
  const [consent, setConsent] = useState(false);

  useEffect(() => {
    try {
      const v = window.localStorage.getItem("pdfconvert_cookie_consent");
      setConsent(v === "accepted");
    } catch {
      setConsent(false);
    }
  }, []);

  // ⚠️ Mets tes vrais IDs (sinon AdSlot n’affiche rien, mais ne plantera pas)
  const ADS_CLIENT = "ca-pub-4717440096189113";
  const SLOT_LEFT = "5088070833";
  const SLOT_RIGHT = "7522662480";

  return (
    <div className="page-ads-layout">
      {consent && (
        <aside className="side-ad left" aria-label="Publicité gauche">
          <AdSlot client={ADS_CLIENT} slot={SLOT_LEFT} />
        </aside>
      )}

      <main className="page-content">{children}</main>

      {consent && (
        <aside className="side-ad right" aria-label="Publicité droite">
          <AdSlot client={ADS_CLIENT} slot={SLOT_RIGHT} />
        </aside>
      )}
    </div>
  );
}
